<template>
  <div class='enquiry-form__container'>
    <p class='enquiry-form__p-text'>We would be glad to answer your questions.</p>
    <form action="send_mail.php" name="contactform" method="post">
      <div class='enquiry-form__input-field'>
        <label class='enquiry-form__input-label'>Name*</label>
        <input class='enquiry-form__input' type='text' name="name">
      </div>
      <div class='enquiry-form__input-field'>
        <label class='enquiry-form__input-label'>Email*</label>
        <input class='enquiry-form__input' type='text' name="email">
      </div>
      <div class='enquiry-form__input-field'>
        <label class='enquiry-form__input-label'>Phone no.</label>
        <input class='enquiry-form__input' type='text' name="phone">
      </div>
      <div class='enquiry-form__input-field'>
        <label class='enquiry-form__input-label'>Company Name</label>
        <input class='enquiry-form__input' type='text' name="company">
      </div>
      <div class='enquiry-form__input-field'>
        <label>Your Message</label>
        <textarea class='enquiry-form__textarea' name="message"></textarea>
      </div>
      <div class='enquiry-form__button-container'>
        <button class='enquire-form__button' type='submit'>SEND MESSAGE</button>
      </div>  
    </form>
  </div>
</template>

<script>
export default {
  name: 'EnquiryForm',
  props: {
  }
}
</script>

<style lang="scss">
@import '../sass/_variables.scss';

.enquiry-form__container {
  border: 2px solid $bdc-light-grey;
  padding: 25px;
  border-radius: 10px;

  @media (max-width: $md-screen) {
    padding: 10px;
  }
}

.enquiry-form__p-text { 
  text-align: center;

  @media (max-width: $md-screen) {
    margin: 5px 0;
  }
}

.enquiry-form__input {
  height: 35px;
  width: calc(100% - 195px);
  font-size: $fs-medium-large;
  color: $fc-dark-grey; 
  padding: 5px 10px;
  background-color: $bg-grey;
  border-radius: 5px;
  border: none;

  @media (max-width: $md-screen) {
    width: calc(100% - 20px);
    height: 30px;
  }
}

.enquiry-form__input-field {
  margin: 20px 0;

  @media (max-width: $md-screen) {
    margin: 10px 0;
  }
}

.enquiry-form__input-label {
  display: inline-block;
  min-width: 175px;
  white-space: wrap;

  @media (max-width: $md-screen) {
    min-width: 120px;
    width: 120px;
    vertical-align: middle;
  }
}

.enquiry-form__textarea {
  display: block;
  width: -webkit-fill-available;
  height: 150px;
  background-color: $bg-grey;
  color: $fc-dark-grey; 
  font-size: $fs-medium-large;
  padding: 5px 10px;
  margin-top: 5px;
  border-radius: 5px;
  border: none;
  overflow: auto;
  resize: none;
}

.enquiry-form__button-container {
  text-align: center;
  margin-top: 40px;
}

.enquire-form__button {
  background: $bg-red;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: $fs-medium-large;
  color: $fc-white;
  cursor: pointer;
}
</style>